import { CM_BASE_URL } from '../../pages/constants/cmConstants';
import { axios } from './common';

export const fetchDepartments = async () => {
  const response = await axios.get(`${CM_BASE_URL}/departments`);

  if (response.status !== 200) {
    throw { message: 'Failed to fetch departments' };
  }

  return response.data;
};
